class VetModal extends HTMLElement {
  constructor() {
    super();

    this.state = {
      vets: [],
      clinics: [],
      allClinics: [],      // holds full API result
      clinicPage: 1,
      clinicPageSize: 10,
      isLoading: false,
      debounceTimer: null
    };
  }

  connectedCallback() {
    this.initializeComponent();
  }

  initializeComponent() {
    this.cacheElements();
    this.initChoices();
    this.attachEventListeners();
    this.initLiveValidation();
  }
  initChoices() {
    window.choicesInstances = {};
    const el = document.getElementById('state');
      if (!el) return;
      window.choicesInstances['state'] = new Choices(el, {
        searchEnabled: true,
        searchResultLimit: -1,
        itemSelectText: '',
        shouldSort: false
      });
  }

  cacheElements() {
    this.elements = {
      RxModal: document.getElementById('PetVetModal'),
      feedback: this.querySelector("#feedbackMessage"),
      addModal: this.querySelector('[data-modal="add-vet-modal"]'),
      addPopup: document.querySelector('#add-vet-btn'),
      save: this.querySelector('#saveVetButton'),
      cancel: this.querySelector('#cancelButton'),
      close: this.querySelector('#modalClose'),
      form: this.querySelector("#vetForm"),
    };
  }

  attachEventListeners() {
    this.elements.save?.addEventListener("click", (event) => {
      event.preventDefault();
      this.handleFormSubmit(event);
    });

    this.elements.addPopup?.addEventListener("click", () => this.addModal());
    this.elements.close?.addEventListener("click", (e) => this.closeModal());
    this.elements.cancel?.addEventListener("click", () => this.closeModal());
  }

  async createVet(payload) {
    const response = await APIrequest("upsertClinic", payload);
    return response?.data?.vet || null;
  }

  setLoading(isLoading) {
    this.state.isLoading = isLoading;
  }
  async handleFormSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;

    const submitBtn =
      form.querySelector('button[type="submit"]') ||
      document.getElementById('saveVetButton'); // fallback

    if (!submitBtn) {
      console.error("Submit button not found");
      return;
    }

    const originalText = submitBtn.innerText;

    // Set loading state
    submitBtn.innerText = "Saving...";
    submitBtn.disabled = true;

    const payload = this.getFormData();
    if (!payload) {
      submitBtn.innerText = originalText;
      submitBtn.disabled = false;
      return;
    }

    try {
        const newVet = await this.createVet(payload);
        await fetchVets();
        if (newVet) {
          this.state.vets.push(newVet);
          let choiceObject = window.choicesInstances['vet-select'];
          choiceObject.setChoiceByValue(newVet.id);
            vetSelect({target: document.getElementById('vet-select')});
          
        }
      this.resetForm();
      this.closeModal();

    } catch (error) {
      console.error(error);
      this.closeModal();
      this.closeModal();
    } finally {
      // Restore button state
      submitBtn.innerText = originalText;
      submitBtn.disabled = false;
    }
  }

  getFormData() {
    this.clearAllErrors();
    const form = this.elements.form;
    const formData = new FormData(form);

    const title = formData.get('title')?.trim();
    const vet_name = formData.get('vet_name')?.trim();
    const phone = formData.get('phone')?.trim();
    const fax = formData.get('fax')?.trim();
    const address_1 = formData.get('address_1')?.trim();
    const address_2 = formData.get('address_2')?.trim();
    const city = formData.get('city')?.trim();
    const state = window.choicesInstances['state'].getValue(true);
    const zip = formData.get('zip')?.trim();

    const phoneRegex = /^(?:\+1\s?)?(?:\(?[2-9]\d{2}\)?[\s.-]?)?[2-9]\d{2}[\s.-]?\d{4}$/;
    const zipRegex = /^\d{5}(-\d{4})?$/;

    let hasError = false;

    if (!title) {
      this.showFieldError(form.title, window.comapny);
      hasError = true;
    }
    if (!vet_name) {
      this.showFieldError(form.vet_name, window.vet_name);
      hasError = true;
    }
    if (!phone) {
      this.showFieldError(form.phone, window.phone);
      hasError = true;
    } else if (!phoneRegex.test(phone)) {
      this.showFieldError(form.phone, window.phone_incorrect);
      hasError = true;
    }
    // Fax is optional — only validate format if a value was entered
    if (fax && !phoneRegex.test(fax)) {
      this.showFieldError(form.fax, 'Enter a valid fax number');
      hasError = true;
    }
    if (!zip) {
      this.showFieldError(form.zip, window.zip);
      hasError = true;
    } else if (!zipRegex.test(zip)) {
      this.showFieldError(form.zip, window.zip_incorrect);
      hasError = true;
    }
    if (!address_1) {
      this.showFieldError(form.address_1, window.address1);
      hasError = true;
    }
    // if (!address_2) {
    //   this.showFieldError(form.address_2, window.address2);
    //   hasError = true;
    // }
    if (!city) {
      this.showFieldError(form.city, window.city);
      hasError = true;
    }
    if (!state) {
      this.showFieldError(form.state, window.state);
      hasError = true;
    }

    if (hasError) return null;

    return {
      handle: formData.get('handle') || undefined,
      title,
      vet_name,
      phone,
      fax,
      address_1,
      address_2,
      city,
      state,
      zip,
    };
  }

  resetForm() {
    this.elements.form?.reset();
    const form = this.elements.form;
    if (form?.handle) form.handle.value = "";
  }

  addModal() {
    this.resetForm();
    this.clearAllErrors()
    this.elements.RxModal.close();
    this.elements.addModal?.classList.add('model-open');
  }

  closeModal() {
    this.elements.addModal?.classList.remove('model-open');
    this.elements.RxModal.showModal();
  }

  showFieldError(field, message) {
    if (!field) return;

    this.clearFieldError(field);

    let parent =
      field.closest('.field-group') ||
      field.closest('.choices') ||
      field.parentElement;


    field.classList.add('field-error');

    // highlight choices dropdown
    const choicesWrapper = field.closest('.choices');
    if (choicesWrapper) choicesWrapper.classList.add('is-error');

    if (parent?.querySelector('.field-error-message')) return;

    const errorEl = document.createElement('div');
    errorEl.className = 'field-error-message';
    errorEl.textContent = message;
    parent?.appendChild(errorEl);
  }

  clearFieldError(field) {
    if (!field) return;
    field.classList.remove('field-error');

    const group = field.closest('.field-group');
    group?.classList.remove('is-error');

    const choices = field.closest('.choices');
    choices?.classList.remove('is-error');

    const errorEl = group?.querySelector('.field-error-message');
    if (errorEl) errorEl.remove();
  }

  clearAllErrors() {
    const fields = this.querySelectorAll('.field-input, select');
    fields.forEach(field => this.clearFieldError(field));
  }

  initLiveValidation() {
    const form = this.elements.form;
    const phoneRegex = /^(?:\+1\s?)?(?:\(?[2-9]\d{2}\)?[\s.-]?)?[2-9]\d{2}[\s.-]?\d{4}$/;
    const zipRegex = /^\d{5}(-\d{4})?$/;
    const optionalFields = ['fax','address_2'];

    form.querySelectorAll('input, textarea').forEach((field) => {
      field.addEventListener('input', () => {
        const value = field.value.trim();
        this.clearFieldError(field);

        if (field.name === 'phone' && value && !phoneRegex.test(value)) {
          this.showFieldError(field, 'Enter valid US phone number');
        }
        if (field.name === 'fax' && value && !phoneRegex.test(value)) {   // ← only validate format if filled
          this.showFieldError(field, 'Enter a valid fax number');
        }
        if (field.name === 'zip' && value && !zipRegex.test(value)) {
          this.showFieldError(field, 'Invalid ZIP (12345 or 12345-6789)');
        }
        if (['title', 'vet_name', 'address_1', 'city', 'state'].includes(field.name) && !value) {
          this.showFieldError(field, 'This field is required');
        }
      });

      field.addEventListener('blur', () => {
        // Skip optional fields — never show required error for them
        if (optionalFields.includes(field.name)) return;
        if (!field.value.trim()) {
          this.showFieldError(field, 'This field is required');
        }
      });
    });
  }

  escapeHtml(value = "") {
    return value.replace(/[&<>"']/g, (char) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    }[char]));
  }
}

customElements.define("vet-modal", VetModal);
